import React from 'react';
import { Alert } from '@edgebox/react-components';
import { useLocation, useParams } from 'react-router';
import { AppContext, IAppContext } from '../../../common/contexts/AppContext';
import { WithPromise } from '../../../common/helpers/WithPromise';
import { Embed } from '../../Shared/Embed';

function BrandPresenceComponent() {
  const location = useLocation();
  const params = useParams<{ project: string }>();
  const projectId = params.project;
  const projectBasePath = location.pathname.match(/^\/projects\/[^/]+/)?.[0];
  const basePath = projectBasePath || (projectId ? `/projects/${projectId}` : undefined);
  const brandPresencePath =
    basePath && location.pathname.startsWith(basePath) ? `${location.pathname.substring(basePath.length)}${location.search}` : undefined;

  return (
    <>
      <AppContext.Consumer>
        {(appContext?: IAppContext) => {
          const project = appContext?.project;
          if (!project) {
            return <Alert variant="light">Please select a project to continue.</Alert>;
          }

          return (
            <WithPromise promise={appContext!.syncCore()}>
              {(syncCore) =>
                syncCore ? (
                  <div className="brand-presence-frame w-100">
                    <Embed
                      key={`${appContext!.projectKey}-brand-presence`}
                      embed="brand-presence"
                      scope="configuration"
                      syncCore={syncCore}
                      project={project}
                      options={{
                        brandPresencePageBackground: true,
                        brandPresencePath,
                        projectUuid: project.uuid,
                      }}
                    />
                  </div>
                ) : (
                  <Alert variant="light">Please select a project to continue.</Alert>
                )
              }
            </WithPromise>
          );
        }}
      </AppContext.Consumer>
    </>
  );
}

export const BrandPresence = BrandPresenceComponent;
